import { fetchJson } from './apiClient';

export interface AdminAdResponse {
  id: string;
  ownerId?: string;
  title?: string;
  description?: string;
  image?: string;
  link?: string;
  price?: string | number;
  clicks?: number;
  redirects?: number;
  views?: number;
  ctr?: number;
  isActive?: boolean;
  approvalStatus?: string;
  targetAudience?: any;
  schedule?: any;
  billingMode?: string;
  budgetTotal?: number;
  budgetRemaining?: number;
  runDays?: number;
  status?: string;
  rejectionReason?: string;
  createdAt?: string;
  updatedAt?: string;
  public?: boolean;
}

export async function listAdminAds(): Promise<AdminAdResponse[]> {
  try {
    const ads = await fetchJson('/api/admin/ads');
    if (Array.isArray(ads)) return ads as AdminAdResponse[];
    return [];
  } catch {
    return [];
  }
}
